  (function () {
    if (window.customElements.get('kr-story')) return;

    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');
    var DESKTOP = window.matchMedia('(min-width: 990px)');

    /* Klaar betekent: binnen en gedecodeerd, dus meteen te tonen. */
    function whenReady(img) {
      return new Promise(function (resolve) {
        var listen = function () {
          if (img.complete) return resolve(img.naturalWidth > 0);
          img.addEventListener('load', function () { resolve(true); }, { once: true });
          img.addEventListener('error', function () { resolve(false); }, { once: true });
        };
        if (typeof img.decode === 'function') {
          img.decode().then(function () { resolve(true); }, listen);
          return;
        }
        listen();
      });
    }

    /* Smoothstep: vloeiende easing zonder overshoot, voor elke 0..1-overgang. */
    function smoothstep(t) {
      t = Math.min(1, Math.max(0, t));
      return t * t * (3 - 2 * t);
    }

    window.customElements.define(
      'kr-story',
      class extends HTMLElement {
        connectedCallback() {
          this.frames = Array.prototype.slice.call(this.querySelectorAll('[data-kr-frame]'));
          this.chapters = Array.prototype.slice.call(this.querySelectorAll('[data-kr-chapter]'));
          this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-kr-dot]'));
          if (!this.frames.length || !this.chapters.length) return;

          var self = this;
          this.groups = this.chapters.map(function (chapter, index) {
            return {
              frames: self.frames.filter(function (frame) {
                return Number(frame.dataset.chapter) === index;
              }),
              ready: false,
              loading: false
            };
          });

          this.ticking = false;
          this.raf = null;
          this.nearViewport = !('IntersectionObserver' in window);
          this.nearChapters = new Set();
          this.onScroll = this.onScroll.bind(this);
          this.onResize = this.onResize.bind(this);
          this.apply = this.apply.bind(this);

          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onResize, { passive: true });
          if (REDUCED.addEventListener) REDUCED.addEventListener('change', this.onResize);
          if (DESKTOP.addEventListener) DESKTOP.addEventListener('change', this.onResize);

          /* Een naderende reeks wordt in zijn geheel opgehaald en gedecodeerd. */
          if ('IntersectionObserver' in window) {
            this.io = new IntersectionObserver(
              function (entries) {
                entries.forEach(function (entry) {
                  var index = Number(entry.target.dataset.krChapter);
                  if (entry.isIntersecting) {
                    self.nearChapters.add(index);
                    self.prepare(index);
                  } else {
                    self.nearChapters.delete(index);
                  }
                });
              },
              { rootMargin: '120% 0px 120% 0px' }
            );
            this.chapters.forEach(function (chapter) { self.io.observe(chapter); });
            this.visibilityObserver = new IntersectionObserver(
              function (entries) {
                self.nearViewport = entries.some(function (entry) { return entry.isIntersecting; });
                if (self.nearViewport) self.onScroll();
              },
              { rootMargin: '25% 0px 25% 0px' }
            );
            this.visibilityObserver.observe(this);
          } else {
            this.groups.forEach(function (group, index) { self.prepare(index); });
          }

          this.apply();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onResize);
          if (REDUCED.removeEventListener) REDUCED.removeEventListener('change', this.onResize);
          if (DESKTOP.removeEventListener) DESKTOP.removeEventListener('change', this.onResize);
          if (this.io) this.io.disconnect();
          if (this.visibilityObserver) this.visibilityObserver.disconnect();
          if (this.raf !== null) window.cancelAnimationFrame(this.raf);
          this.raf = null;
          this.ticking = false;
        }

        /* Mobiel staat het podium op display:none; daar hoeft niets te laden. */
        prepare(index) {
          var group = this.groups[index];
          if (!group || group.ready || group.loading) return;
          if (!(DESKTOP.matches && !REDUCED.matches)) return;

          group.loading = true;

          var self = this;
          var pending = group.frames.length;
          var complete = true;

          group.frames.forEach(function (img) {
            img.loading = 'eager';
            whenReady(img).then(function (ok) {
              if (ok) img.dataset.ready = 'true';
              else complete = false;
              pending -= 1;
              if (pending === 0) {
                group.loading = false;
                group.ready = complete;
              }
              self.onScroll();
            });
          });
        }

        /* Scroll updates are unnecessary when the sequence cannot be seen. */
        onScroll() {
          if (!this.isConnected || !this.nearViewport || !DESKTOP.matches || REDUCED.matches) return;
          this.schedule();
        }

        /* Mode changes must still reset the static layout, even off screen. */
        onResize() {
          if (!this.isConnected) return;
          var self = this;
          if (this.io) {
            this.nearChapters.forEach(function (index) { self.prepare(index); });
          } else {
            this.groups.forEach(function (group, index) { self.prepare(index); });
          }
          this.schedule();
        }

        /* At most one pending frame, cancelled on section removal. */
        schedule() {
          if (this.ticking) return;
          this.ticking = true;
          this.raf = window.requestAnimationFrame(
            function () {
              this.raf = null;
              this.ticking = false;
              if (this.isConnected) this.apply();
            }.bind(this)
          );
        }

        /* Buiten desktop, of bij reduced motion, blijft alles statisch. */
        apply() {
          var animated = DESKTOP.matches && !REDUCED.matches;
          this.toggleAttribute('data-animated', animated);

          if (!animated) {
            this.frames.forEach(function (frame) {
              frame.style.opacity = '';
            });
            this.chapters.forEach(function (chapter) {
              chapter.removeAttribute('data-active');
            });
            return;
          }

          var line = window.innerHeight * 0.5;
          var active = 0;
          var local = 0;

          for (var i = 0; i < this.chapters.length; i++) {
            var rect = this.chapters[i].getBoundingClientRect();
            if (rect.top <= line || i === 0) {
              active = i;
              local = (line - rect.top) / Math.max(rect.height, 1);
            }
          }
          local = Math.min(1, Math.max(0, local));

          /*
           * De eerste 15% van een nieuw hoofdstuk is gereserveerd voor de
           * overgang tussen hoofdstukken: het laatste frame van het vorige
           * hoofdstuk en het eerste frame van dit hoofdstuk kruisen daar samen
           * op. Pas daarna begint de interne reeks van dit hoofdstuk. Het
           * eerste hoofdstuk heeft geen vorig hoofdstuk en slaat deze zone over.
           */
          var zone = 0.15;
          var inChapterBlend = active > 0 && local < zone;

          if (inChapterBlend) {
            var chapterBlend = smoothstep(local / zone);
            var enteringReady = this.paintEntering(this.groups[active], chapterBlend);
            this.paintLeaving(this.groups[active - 1], chapterBlend, enteringReady);
            for (var c = 0; c < this.groups.length; c++) {
              if (c !== active && c !== active - 1) this.paint(this.groups[c], -1);
            }
          } else {
            var innerProgress = active > 0 ? (local - zone) / (1 - zone) : local;
            innerProgress = Math.min(1, Math.max(0, innerProgress));
            for (var d = 0; d < this.groups.length; d++) {
              this.paint(this.groups[d], d === active ? innerProgress : -1);
            }
          }

          this.chapters.forEach(function (chapter, index) {
            chapter.toggleAttribute('data-active', index === active);
          });
          this.dots.forEach(function (dot, index) {
            dot.toggleAttribute('data-active', index === active);
          });
        }

        /**
         * progress < 0 betekent: hoofdstuk niet actief, alles uit.
         * Anders 0..1 over de interne reeks. Er staan ooit precies twee
         * aangrenzende frames aan en hun opacity telt altijd op tot 1: geen
         * dubbele volle belichting, geen grijs podium ertussen.
         */
        paint(group, progress) {
          var frames = group.frames;
          var i;
          if (!frames.length) return;

          if (progress < 0) {
            for (i = 0; i < frames.length; i++) frames[i].style.opacity = '0';
            return;
          }

          if (!group.ready) {
            /*
             * Nog niet alles binnen: het eerste volledig geladen beeld vasthouden.
             * Is er nog niets gedecodeerd, dan blijft frame 1 aan staan; anders zou
             * het lege podium een tel lang grijs zijn.
             */
            var first = 0;
            for (i = 0; i < frames.length; i++) {
              if (frames[i].dataset.ready === 'true') {
                first = i;
                break;
              }
            }
            for (i = 0; i < frames.length; i++) frames[i].style.opacity = i === first ? '1' : '0';
            return;
          }

          var last = frames.length - 1;
          var pos = progress * last;
          var base = Math.floor(pos);
          if (base > last - 1) base = last - 1;
          if (base < 0) base = 0;
          var frac = last > 0 ? pos - base : 0;
          if (frac < 0) frac = 0;
          if (frac > 1) frac = 1;
          var eased = smoothstep(frac);

          for (i = 0; i < frames.length; i++) {
            var value = 0;
            if (i === base) value = 1 - eased;
            else if (i === base + 1) value = eased;
            frames[i].style.opacity = String(value);
          }
        }

        /**
         * Hoofdstukovergang, instromende kant: alleen het eerste frame van dit
         * hoofdstuk komt op, van 0 naar blend. De interne reeks is nog niet aan
         * de beurt. Is dat eerste frame nog niet klaar, dan blijft dit
         * hoofdstuk volledig onzichtbaar, zodat het vorige hoofdstuk in beeld
         * blijft in plaats van een leeg podium.
         * @returns {boolean} of het eerste frame al klaar is
         */
        paintEntering(group, blend) {
          var frames = group.frames;
          if (!frames.length) return false;
          var ready = frames[0].dataset.ready === 'true';
          for (var i = 0; i < frames.length; i++) {
            frames[i].style.opacity = i === 0 && ready ? String(blend) : '0';
          }
          return ready;
        }

        /**
         * Hoofdstukovergang, uitstromende kant: het laatste frame van het
         * vorige hoofdstuk dooft van 1 naar 0, samen optellend met het
         * instromende frame tot 1. Zolang het instromende beeld nog niet klaar
         * is, blijft dit beeld op 1 staan.
         */
        paintLeaving(group, blend, enteringReady) {
          var frames = group.frames;
          if (!frames.length) return;
          var last = frames.length - 1;
          var value = enteringReady ? 1 - blend : 1;
          for (var i = 0; i < frames.length; i++) {
            frames[i].style.opacity = i === last ? String(value) : '0';
          }
        }
      }
    );
  })();
